import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../service/config/config.service';
import { LogicService } from '../service/logic/logic.service';
import { StorageInfoService } from '../service/storage-info/storage-info.service';
import { StorageService } from '../service/storage/storage.service';
import { StringVariableService } from '../service/string-variable/string-variable.service';
import { ValidationService } from '../service/validation/validation.service';
import { WorkflowDictionaryService } from '../service/workflow-dictionary/workflow-dictionary.service';
import { WorkflowWidgetEventServiceService } from '../widget/workflow-widget-event.service';

import { PrimitiveType, Storage, Workflow, WorkflowCard, WorkflowEnum, WorkflowField, WorkflowPage } from './workflow.type';
import { StateManagementService } from '@workflow/service/state-management/state-management.service';

interface WorkflowDependencies {
  config: {
    apiEnums: { [id: string]: PrimitiveType[] };
    cards: { [id: string]: WorkflowCard };
    enums: { [id: string]: WorkflowEnum };
    fields: { [id: string]: WorkflowField };
    flows: { [id: string]: Workflow };
    pages: { [id: string]: WorkflowPage };
    storage: { [protocol: string]: { [id: string]: Storage } };
    workflowSpecificFields: { [id: string]: WorkflowField };
    workflowSpecificCards: { [id: string]: WorkflowCard };
    workflowSpecificPages: { [id: string]: WorkflowPage };
  };
  configService: ConfigService;
  dictionaryService: WorkflowDictionaryService;
  httpClient: HttpClient;
  logicService: LogicService;
  storageInfoService: StorageInfoService;
  storageService: StorageService;
  stringVariableService: StringVariableService;
  validationService: ValidationService;
  widgetEventService: WorkflowWidgetEventServiceService;
  stateManagementService: StateManagementService;
}

/**
 * Should be loaded as WorkflowService initializes
 */
export const dependencies: Partial<WorkflowDependencies> = {};
